export * from './user-info-edit/user-info-edit.component';
export * from './user-info-view/user-info-view.component';
export * from './user-info.component';
export * from './user-info.module';
export * from './services';
